import { PowerPlugBatteryIcon } from './PowerPlugBatteryIcon';

/**
 * author: Jeff Anders
 * id 1F41CB15-B611-4FBF-A789-7A404C7D81D1
 * name power-plug-battery
 * version: 7.2.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/power-plug-battery.svg
 * tags
 * - Home Automation 
 * - Battery 
 */
export const BatteryBackupIcon = PowerPlugBatteryIcon;
export default BatteryBackupIcon